function addScreenshot(source, target, callback, windowWidth, windowHeight) {
    html2canvas(source[0], {
        allowTaint: true,
        logging: true,
        windowWidth: windowWidth,
        windowHeight: windowHeight,
    }).then(function (canvas) {
            let scrBase64 = canvas.toDataURL('image/png');
            scrBase64 = scrBase64.split(',')[1];
            target.attr('src', 'data:image/png;base64,' + scrBase64);
            callback();
        }
    );
}
